import './index.scss';
import init from '@/360pc';

init({
  qrcodeId: ['#qrcode', '#dialogQRcode', '#teacher-qrcode'],
  qrcodeSize: {
    '#qrcode': {
      width: 200,
      height: 200
    },
    '#dialogQRcode': {
      width: 260,
      height: 260
    },
    '#teacher-qrcode': {
      width: 180,
      height: 180
    }
  },
  page_number: 'yd10788',
  isQrInfo: true
});

$('.dialog-container-mask').on('click', (e) => {
  $('.dialog-container-mask').fadeOut();
});

$('.get-btn').on('click', (e) => {
  $('.dialog-container-mask').fadeIn();
});

function handleScroll() {
  $(document).scroll(function () {
    const scrollHeight = $(document).scrollTop();
    if (scrollHeight > 800) {
      $('.bottom-con').fadeIn();
      $('.right-popup').fadeIn();
    } else {
      $('.bottom-con').fadeOut();
      $('.right-popup').fadeOut();
    }
  });
}

handleScroll();

const mainSwiper = new Swiper('.swiper-container', {
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  },
  initialSlide: 1
});

// 当幻灯片切换时，更新按钮样式和图片
mainSwiper.on('slideChange', function () {
  const activeIndex = this.activeIndex % 3; // 考虑循环模式
  $('.goToSlide').removeClass('active');
  $('.goToSlide').each(function (index) {
    const img = $(this).find('.img-icon');
    if (index === activeIndex) {
      $(this).addClass('active');
      img.attr('src', img.data('alt-src'));
    } else {
      img.attr('src', img.attr('src').replace('icon2', 'icon1'));
    }
  });
});

// 鼠标悬停在按钮上时，停止自动轮播并切换到对应幻灯片
$('.btn0, .btn1, .btn2').hover(
  function () {
    mainSwiper.autoplay.stop();
    const index = $(this).index();
    mainSwiper.slideTo(index, 300, false);
  },
  function () {
    mainSwiper.autoplay.start();
  }
);

// 初始化时，设置第一个按钮为激活状态，并手动触发 slideChange 事件
$('.goToSlide').eq(0).addClass('active');
mainSwiper.emit('slideChange');

$(document).ready(() => {
  const swiperContainer = $('.swiper-container1');
  swiperContainer.css({
    width: '100%',
    height: '100%'
  });

  const swiper = new Swiper('.swiper-container1', {
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    on: {
      init: () => {
        console.log('Swiper initialized successfully');
      },
      slideChange: function () {
        console.log('Slide changed to:', this.activeIndex);
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const swiperContainer = document.querySelector('.swiper-container1');
  const swiperWrapper = document.querySelector('.swiper-wrapper1');
  const swiperSlides = document.querySelectorAll('.part6-swiper-slide');
  const prevButton = document.querySelector('.swiper-button-prev');
  const nextButton = document.querySelector('.swiper-button-next');

  if (!swiperContainer || swiperSlides.length < 1) {
    return;
  }

  let slideWidth = 0;
  try {
    slideWidth = swiperSlides[0].offsetWidth;
    if (slideWidth <= 0) throw new Error('宽度为0');
  } catch (e) {
    slideWidth = 500;
  }

  const totalRealSlides = swiperSlides.length;
  const totalSlides = totalRealSlides + 2;

  const firstSlideClone = swiperSlides[0].cloneNode(true);
  const lastSlideClone = swiperSlides[totalRealSlides - 1].cloneNode(true);

  swiperWrapper.appendChild(firstSlideClone);
  swiperWrapper.insertBefore(lastSlideClone, swiperWrapper.firstChild);

  swiperWrapper.style.width = totalSlides * slideWidth + 'px';

  let currentIndex = 1;
  swiperWrapper.style.transform = `translateX(-${currentIndex * slideWidth}px)`;

  function goToSlide(index) {
    if (index < 0) {
      index = totalSlides - 1;
    } else if (index >= totalSlides) {
      index = 0;
    }

    swiperWrapper.style.transition = 'transform 0.5s ease';
    swiperWrapper.style.transform = `translateX(-${index * slideWidth}px)`;

    setTimeout(() => {
      if (index === 0) {
        currentIndex = totalRealSlides;
        swiperWrapper.style.transition = 'none';
        swiperWrapper.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
      } else if (index === totalSlides - 1) {
        currentIndex = 1;
        swiperWrapper.style.transition = 'none';
        swiperWrapper.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
      } else {
        currentIndex = index;
      }
    }, 500);
  }

  prevButton.addEventListener('click', () => goToSlide(currentIndex - 1));
  nextButton.addEventListener('click', () => goToSlide(currentIndex + 1));

  let autoPlayInterval;
  function startAutoPlay() {
    autoPlayInterval = setInterval(() => {
      goToSlide(currentIndex + 1);
    }, 3000);
  }

  function stopAutoPlay() {
    clearInterval(autoPlayInterval);
  }

  startAutoPlay();

  swiperContainer.addEventListener('mouseenter', stopAutoPlay);
  swiperContainer.addEventListener('mouseleave', startAutoPlay);

  window.addEventListener('resize', () => {
    try {
      slideWidth = swiperSlides[0].offsetWidth;
      if (slideWidth <= 0) throw new Error('宽度为0');

      swiperWrapper.style.width = totalSlides * slideWidth + 'px';
      goToSlide(currentIndex);
    } catch (e) {
      console.log('Resize处理错误', e);
    }
  });

  console.log('Part6轮播初始化完成，幻灯片数量:', totalSlides);
});

const leftImage = document.querySelector('.left-image');
const rightImage = document.querySelector('.right-image');

rightImage.classList.add('small');
leftImage.classList.add('normal');

leftImage.addEventListener('mouseenter', () => {
  leftImage.classList.remove('small');
  leftImage.classList.add('normal', 'hover-effect');

  rightImage.classList.remove('normal');
  rightImage.classList.add('small');
});

leftImage.addEventListener('mouseleave', () => {
  leftImage.classList.remove('hover-effect');
});

rightImage.addEventListener('mouseenter', () => {
  rightImage.classList.remove('small');
  rightImage.classList.add('normal', 'hover-effect');

  leftImage.classList.remove('normal');
  leftImage.classList.add('small');
});

rightImage.addEventListener('mouseleave', () => {
  rightImage.classList.remove('hover-effect');
});
